export default __webpack_public_path__ + "static/media/search.1dfac630.png";